import useResident from 'hooks/useResident'
import PersonalContactForm from '../forms/PersonalContactForm'
import { Navigate, useParams } from 'react-router-dom'

const ResidentPersonalContactCreateScreen = () => {
  const { id } = useParams()

  if (!id) {
    return <Navigate to="/residents" />
  }
  const { isLoading, resident, updateResident } = useResident({ id })

  return (
    <PersonalContactForm
      editedIndex={undefined}
      onSubmit={updateResident}
      isLoading={isLoading}
      resident={resident}
    />
  )
}

export default ResidentPersonalContactCreateScreen
